module.exports = __webpack_public_path__ + "static/media/oneColumnReverse.fbed9e15.svg";